// extracted by mini-css-extract-plugin
export default {"backdrop":"PopUp_backdrop__QHs3m","modal":"PopUp_modal__BUhnp","actions":"PopUp_actions__EYXSH"};